import { Redirect, useLocalSearchParams } from "expo-router";

const DetailedListItemTypesRedirect = () => {
	const { id, examName } = useLocalSearchParams<{
		id: string;
		examName?: string;
	}>();

	return (
		<Redirect
			href={{
				pathname: "/(protected)/session/[id]/report/types",
				params: { id, examName: examName ?? "" },
			}}
		/>
	);
};

export default DetailedListItemTypesRedirect;
